import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';

export const publishDocumentTemplateVersion = async (
  documentTemplateId: string,
  documentTemplateVersionId: string
): Promise<Response> => {
  const res = await fetcher(
    `${BASE_URL}/${documentTemplateId}/version/${documentTemplateVersionId}/publish`,
    {
      method: 'POST',
    }
  );
  return res;
};
